import * as React from 'react';
import loadinggif from "assets/images/loading.gif";
import "./Loading.scss";

const Loading = () => (
    <img className="loadingBar" src={loadinggif} alt="ładowanie..." />
);

export default Loading;